const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/VersicherungsdeckungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const VersicherungsdeckungField = generateMetaKatDropDownField(
    'a3a0c552-b165-430b-91da-e4dff30bc745',
    'VersicherungsdeckungField'
);

export default VersicherungsdeckungField;
